import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import es from './locales/es.json';
import en from './locales/en.json';
import zh from './locales/zh.json';
import ru from './locales/ru.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import el from './locales/el.json';
import hi from './locales/hi.json';
export const SUPPORTED_LOCALES = ['es', 'en', 'zh', 'ru', 'fr', 'de', 'el', 'hi'];
export const LOCALE_LABELS = {
    es: 'Español',
    en: 'English',
    zh: '中文',
    ru: 'Русский',
    fr: 'Français',
    de: 'Deutsch',
    el: 'Ελληνικά',
    hi: 'हिन्दी',
};
void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    resources: {
        es: { translation: es },
        en: { translation: en },
        zh: { translation: zh },
        ru: { translation: ru },
        fr: { translation: fr },
        de: { translation: de },
        el: { translation: el },
        hi: { translation: hi },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LOCALES,
    react: { useSuspense: false },
    interpolation: { escapeValue: false },
    detection: {
        // Evita localStorage en arranque: algunos navegadores/extensiones lo
        // bloquean y pueden dejar la SPA en blanco antes de montar React.
        order: ['querystring', 'navigator', 'htmlTag'],
        caches: [],
        lookupQuerystring: 'lng',
    },
});
export default i18n;
